import { Provider } from '@angular/core';

import { ProfileService } from './profile.service';
import { FormInstancesService } from './form-instances.service';
import { PeFormInstanceService } from './pe-form-instance.service';
import { PipPlansService } from './pip-plans.service';
import { PpFormInstanceService } from './pp-form-instance.service';
import { PhasesService } from './phases.service';
import { FormsService } from './forms.service';
import { FormWorkflowService } from './form-workflow.service';
import { CustomQuestionsItemService } from './custom-questions-item.service';
import { CustomQuestionHeadingService } from './custom-question-heading.service';
import { TemplatesService } from './templates.service';
import { DashboardService } from './dashboard.service';
import { QuizInstancesService } from './quiz-instances.service';
import { AuthService } from './auth.service';
import { NavNotificationsService } from './nav-notifications.service';
import { SitesService } from './sites.service';
import { PpFormsService } from './pp-forms/pp-forms.service';
import { PpFormQuestionHeadingsService } from './pp-forms/pp-form-question-headings.service';
import { PpFormWorkflowStepsService } from './pp-forms/pp-form-workflow-steps.service';
import { PpFormQuestionsService } from './pp-forms/pp-form-questions.service';
import { PeFormsService } from './pe-forms.service';
import { PeFormWorkflowStepsService } from './pe-form-workflow-steps.service';
import { PeFormQuestionHeadingsService } from './pe-form-question-headings.service';
import { PeFormQuestionsService } from './pe-form-questions.service';
import { PerformanceCategoriesService } from './performance-categories.service';
import { PerformanceCategoriesHeadingService } from './performance-categories-heading.service';
import { RatingsService } from './ratings.service';
import { AlertsService } from './alerts.service';
import { PeDashboardService } from './pe-dashboard.service';
import { MtDashboardService } from './program/mentoring/mt-dashboard.service';
import { PerformanceDashboardService } from './performance-dashboard.service';
import { UserManagementService } from './user-management.service';
import { SuperUsersService } from './super-users.service';
import { FormExportService } from './form-export.service';
import { SearchService } from './search.service';
import { TextImageEditorService } from './text-image-editor.service';
import { IncidentTypesService } from './incident-types.service';
import { ResourceFoldersService } from './resources-folders.service';
import { AttachmentsService } from './attachments.service';
import { PpReportsService } from './pp-reports.service';
import { CorrectiveActionsService } from './corrective-actions.service';
import { TraineeSuccessReportService } from './program/field-training/reports/trainee-success-report.service';
import { InterestsService } from './interests.service';
import { UserGoalsService } from './user-goals.service';
import { MtProgramUsersService } from './program/mentoring/mt-program-users.service';
import { MtConversationsService } from './program/mentoring/mt-conversations.service';
import { MtPairsService } from './program/mentoring/mt-pairs.service';
import { MtMatchingService } from './program/mentoring/mt-matching.service';
import { ConversationsReportService } from './program/mentoring/reports/conversations-report.service';
import { GoalsReportService } from './program/mentoring/reports/goals-report.service';
import { HighFivesService } from './program/performance-evaluation/high-fives.service';
import { SystemAdministrationDashboardService } from './system-administration-dashboard.service';
import { SiteDashboardService } from './site-dashboard.service';
import { ActiveDirectoryService } from './active-directory.service';
import { DocsService } from './docs.service';
import { ProgramUsersService } from './program-users.service';
import { SiteListsService } from '@app/api/api-services';
import { TemplateHeadingsService } from './template.headings.service';
import { ScheduleService } from './schedule.service';
import { ScheduleCachedService } from './schedule-cached.service';
import { ResourcesService } from './resources.service';
import { ReportsService } from './reports.service';
import { PendingTasksService } from './pending-tasks.service';
import { PeReportsService } from './pe-reports.service';
import { ActivitiesService } from './activities.service';
import { QuizzesReportService } from './program/field-training/reports/quizzes-report.service';
import { PowerDmsService } from './power-dms.service';
import { TrainingCoursesService } from './training-courses/training-courses.service';
import { TrainingCourseAttachmentsService } from './training-courses/training-course-attachments.service';
import { TrainingCourseClassesService } from './training-courses/training-course-classes.service';
import { TrainingCourseClassAttendeesService } from './training-courses/training-course-class-attendees.service';
import { TrainingCourseRequestsService } from './training-courses/training-course-requests.service';
import { TrainingCoursesDashboardService } from './training-courses/training-courses-dashboard.service';
import { TrainingCoursesCoordinatorsService } from './training-courses/training-courses-coordinators.service';
import { TraineeHoursReportService } from './program/field-training/reports/trainee-hours-report.service';
import { PowerDmsAddOnService } from './site-settings/add-ons/power-dms-add-on.service';
import { CadIntegrationAddOnService } from './site-settings/add-ons/cad-integration-add-on.service';
import { ActiveDirectoryAddOnService } from './site-settings/add-ons/active-directory-add-on.service';
import { QuizzesService } from './site-settings/quizzes/quizzes.service';
import { QuizWorkflowStepsService } from './site-settings/quizzes/quiz-workflow-steps.service';
import { QuizQuestionsService } from './site-settings/quizzes/quiz-questions.service';
import { QuizQuestionHeadingsService } from './site-settings/quizzes/quiz-question-headings.service';
import { ActivityTypesService } from './site-settings/activity-types.service';
import { AddOnsService } from './site-settings/add-ons.service';
import { AgencyInformationService } from './site-settings/agency-information.service';
import { AuditLogsService } from './site-settings/audit-logs.service';
import { GroupsService } from './site-settings/groups.service';
import { ImprovementActivitiesService } from './site-settings/improvement-activities.service';
import { ImprovementPlanConsequencesService } from './site-settings/improvement-plan-consequences.service';
import { ImprovementPlanReasonsService } from './site-settings/improvement-plan-reasons.service';
import { ImprovementPlanResolutionsService } from './site-settings/improvement-plan-resolutions.service';
import { JobTitlesService } from './site-settings/job-titles.service';
import { LocationsService } from './site-settings/locations.service';
import { ProgramExitTypesService } from './site-settings/program-exit-types.service';
import { ProgramsService } from './site-settings/programs.service';
import { ShiftsService } from './site-settings/shifts.service';
import { ProgramSkillsService } from './program-settings/program-skills.service';
import { ProgramSkillHeadingsService } from './program-settings/program-skill-headings.service';
import { ProgramQuizzesService } from './program-settings/program-quizzes.service';
import { DefaultTasksService } from './program-settings/default-tasks.service';
import { PolicyDocumentTemplatesService } from './policy-document-templates.service';
import { PolicyDocumentSyncService } from './policy-document-sync.service';
import { PolicyDocumentTasksService } from './policy-document-tasks.service';
import { SupportingDocumentsService } from './program/supporting-documents.service';
import { HttpClientService } from './http-client.service';
import { CallTypesService } from '@app/api/api-services/site-settings/call-types.service';
import { SiteCallTypeHeadingsService } from '@app/api/api-services/site-settings/site-call-type-headings.service';
import { ExternalCallTypesService } from './external-call-types.service';
import { AppSettingsService } from './app-settings.service';

export * from './abstractions';
export * from './program';
export * from './site-settings';
export * from './program-settings';
export * from './power-dms.service';
export * from './training-courses';

export const API_SERVICES: Provider[] = [
  HttpClientService,
  ActivitiesService,
  PeReportsService,
  PendingTasksService,
  ReportsService,
  ResourcesService,
  ScheduleCachedService,
  ScheduleService,
  TemplateHeadingsService,
  ProgramUsersService,
  QuizzesReportService,
  PowerDmsService,
  TrainingCoursesService,
  TrainingCourseAttachmentsService,
  TrainingCourseClassesService,
  TrainingCourseClassAttendeesService,
  TrainingCourseRequestsService,
  TrainingCoursesDashboardService,
  TrainingCoursesCoordinatorsService,
  TraineeHoursReportService,
  PowerDmsAddOnService,
  CadIntegrationAddOnService,
  ActiveDirectoryAddOnService,
  QuizzesService,
  QuizWorkflowStepsService,
  QuizQuestionsService,
  QuizQuestionHeadingsService,
  ActivityTypesService,
  AddOnsService,
  AgencyInformationService,
  AuditLogsService,
  GroupsService,
  ImprovementActivitiesService,
  ImprovementPlanConsequencesService,
  ImprovementPlanReasonsService,
  ImprovementPlanResolutionsService,
  JobTitlesService,
  LocationsService,
  ProgramExitTypesService,
  ProgramsService,
  ShiftsService,
  SiteListsService,
  SiteCallTypeHeadingsService,
  CallTypesService,
  ProgramSkillsService,
  ProgramSkillHeadingsService,
  ProgramQuizzesService,
  DefaultTasksService,
  PolicyDocumentTemplatesService,
  PolicyDocumentSyncService,
  PolicyDocumentTasksService,
  SupportingDocumentsService,
  DocsService,
  ActiveDirectoryService,
  ProfileService,
  FormInstancesService,
  PeFormInstanceService,
  PipPlansService,
  PpFormInstanceService,
  PhasesService,
  FormsService,
  FormWorkflowService,
  CustomQuestionsItemService,
  CustomQuestionHeadingService,
  TemplatesService,
  DashboardService,
  QuizInstancesService,
  AuthService,
  NavNotificationsService,
  SitesService,
  PpFormsService,
  PpFormQuestionHeadingsService,
  PpFormWorkflowStepsService,
  PpFormQuestionsService,
  PeFormsService,
  PeFormWorkflowStepsService,
  PeFormQuestionHeadingsService,
  PeFormQuestionsService,
  PerformanceCategoriesService,
  PerformanceCategoriesHeadingService,
  RatingsService,
  AlertsService,
  PeDashboardService,
  MtDashboardService,
  PerformanceDashboardService,
  UserManagementService,
  SuperUsersService,
  FormExportService,
  SearchService,
  TextImageEditorService,
  IncidentTypesService,
  ResourceFoldersService,
  AttachmentsService,
  PpReportsService,
  CorrectiveActionsService,
  TraineeSuccessReportService,
  InterestsService,
  UserGoalsService,
  MtProgramUsersService,
  MtConversationsService,
  MtPairsService,
  MtMatchingService,
  ConversationsReportService,
  GoalsReportService,
  HighFivesService,
  SystemAdministrationDashboardService,
  SiteDashboardService,
  ExternalCallTypesService,
  AppSettingsService
];
